import mod from "-!./script.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./script.js?vue&type=script&lang=js&external"